import type { Notification } from "@/types/notificationTypes"
import "./NotificationsItem.css"

import moment from "moment"

export default function NotificationsItem({
  notification,
}: {
  notification: Notification
}) {
  return (
    <div
      className={`notifications__item ${!notification.read_at ? "unread" : ""}`}
    >
      <div className="d-flex justify-content-between align-items-center w-100">
        <div className="w-100">
          <div className="fw-bold mb-1">{notification.title}</div>

          <div className="text-muted mb-1">
            {notification.content || notification.message}
          </div>

          <div className="notifications__date text-muted mt-1 text-end ltr">
            {notification.time
              ? moment(notification.time).format("YYYY-MM-DD hh:mm A")
              : ""}
          </div>
        </div>

        {!notification.read_at && (
          <span className="notifications__unread flex-shrink-0"></span>
        )}
      </div>
    </div>
  )
}
